/**
 * Thin virtualizer wrapper for long tables — opt-in when row count is large.
 */
import { useRef } from 'react';
import { useVirtualizer } from '@tanstack/react-virtual';

const DEFAULT_THRESHOLD = 80;

export function useTableVirtualizer(rows, { estimateSize = 44, threshold = DEFAULT_THRESHOLD, overscan = 8 } = {}) {
  const parentRef = useRef(null);
  const enabled = Array.isArray(rows) && rows.length >= threshold;
  const virtualizer = useVirtualizer({
    count: enabled ? rows.length : 0,
    getScrollElement: () => parentRef.current,
    estimateSize: () => estimateSize,
    overscan,
  });

  return {
    parentRef,
    enabled,
    virtualizer,
    virtualRows: enabled ? virtualizer.getVirtualItems() : null,
    totalSize: enabled ? virtualizer.getTotalSize() : 0,
  };
}
